import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { current, ThunkDispatch } from "@reduxjs/toolkit";
import { useNavigate } from "react-router-dom";
import { CompanyTopNews, TopJob } from "../../../api/types.gen";
import { fetchCompanyTopNewsAndJob } from "../../../reducers/companyHome";
import { setRankAOnly, setSelectedTypeOfTalent } from "../../../reducers/companyContent";
import { setJobRankAOnly, setJobSelectedTypeOfTalent } from "../../../reducers/companyJob";
import { setCurrentPage } from "../../../reducers/companyJob";
import CustomButton from "../../../components/CustomButton";
import {setSortBy, setSortOrder} from '../../../reducers/companyJob';
type topNewsExcerptProps = {
  idx: number,
  news: CompanyTopNews
}


const CompanyTopNews = ({ idx, news }: topNewsExcerptProps) => {
  const navigate = useNavigate();
  const goToNewsDetail = () => {
    navigate(`/company/news/detail/${news.id}`);
  }
  return (
    <div
      className="flex items-center justify-between"
    >
      <div className="flex-1">
        <p className="cursor-pointer w-[90%] line-clamp-1 text-sm alu-text-base-2 underline underline-offset-1 hover:text-[#FF861A]" 
          style={{ textDecoration: "underline"}}
          onClick={() => goToNewsDetail()}
        >
          {news.title}
        </p>
      </div>
      <div className="shrink-0 flex items-center">
        <p className="text-sm alu-text-base-1"
          onClick={() => goToNewsDetail()}
        >
          {news.pv}PV
        </p>
        <button
         onClick={() => goToNewsDetail()}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
          >
            <g clipPath="url(#clip0_10454_84136)">
              <path
                d="M9.99984 6.48438L8.58984 7.89437L13.1698 12.4844L8.58984 17.0744L9.99984 18.4844L15.9998 12.4844L9.99984 6.48438Z"
                fill="#808080"
              />
            </g>
            <defs>
              <clipPath id="clip0_10454_84136">
                <rect
                  width="24"
                  height="24"
                  fill="white"
                  transform="translate(0 0.484375)"
                />
              </clipPath>
            </defs>
          </svg>
        </button>
      </div>
    </div>
  )
}

const CompanyTopNewsEmpty = ({ text }: any) => {
  return (
    <div className="flex items-center justify-center" style={{ height: "221px" }}>
      <p className="text-center text-sm alu-text-base-2">
        {text}
      </p>
    </div>
  )
}

type topJobsExcerptProp = {
  job: TopJob
}

const CompanyTopJobs = ({ job }: topJobsExcerptProp) => {
  const navigate = useNavigate();
  const goToJobDetail = () => {
    navigate(`/company/job/detail/${job.id}`);
  }
  return (  
    <div
      className="flex items-center justify-between"
    >
      <div className="flex-1">
        <p 
          className="cursor-pointer w-[90%] line-clamp-1 text-sm alu-text-base-2 underline underline-offset-1 hover:text-[#FF861A]"
          onClick={() => goToJobDetail()}
        >
          {job.title}
        </p>
      </div>
      <div className="shrink-0 flex items-center">
        <p className="text-sm alu-text-base-1"
          onClick={() => goToJobDetail()}
        >{job.number_of_views}PV</p>
        <button 
          onClick={() => goToJobDetail()}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
          >
            <g clipPath="url(#clip0_10454_84136)">
              <path
                d="M9.99984 6.48438L8.58984 7.89437L13.1698 12.4844L8.58984 17.0744L9.99984 18.4844L15.9998 12.4844L9.99984 6.48438Z"
                fill="#808080"
              />
            </g>
            <defs>
              <clipPath id="clip0_10454_84136">
                <rect
                  width="24"
                  height="24"
                  fill="white"
                  transform="translate(0 0.484375)"
                />
              </clipPath>
            </defs>
          </svg>
        </button>
      </div>
    </div>
  )
}

const CompanyHomeNewsAndJob = () => {
  const navigate = useNavigate();
  const topNews = useSelector((state: any) => state.companyHome.topNews);
  const topsJobs = useSelector((state: any) => state.companyHome.topJobs);
  const isLoadingTopNews = useSelector((state: any) => state.companyHome.isLoadingTopNews);
  const rankAOnly = useSelector((state: any) => state.companyHome.rankAOnly);
  const selectedTypeOfTalent = useSelector((state: any) => state.companyHome.selectedTypeOfTalent);
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  useEffect(() => {
    dispatch(fetchCompanyTopNewsAndJob({
      rankAonly: rankAOnly ? 1 : 0,
      talentType: selectedTypeOfTalent?.value
    }));
  }, [rankAOnly, selectedTypeOfTalent]);

  const goToJobPage = () => {
    dispatch(setSortBy('number_of_views'));
    dispatch(setSortOrder('desc'));
    dispatch(setJobRankAOnly(rankAOnly));
    dispatch(setJobSelectedTypeOfTalent(selectedTypeOfTalent));
    dispatch(setCurrentPage(1));
    navigate('/company/job', { state: { isFromDetail: false } } );
  }

  const goToContentRaking = () => {
    dispatch(setRankAOnly(rankAOnly));
    if (selectedTypeOfTalent?.value) {
      dispatch(setSelectedTypeOfTalent([selectedTypeOfTalent?.value]));
    } else {
      dispatch(setSelectedTypeOfTalent([]));
    }
    navigate('/company/content-ranking');
  }

  return (
    <div className="flex gap-6">
      <div className="w-[50%]">
        <div className="mb-4 flex items-center justify-between">
          <h5 className="text-xl alu-text-base-2 font-bold">
            よく見られているコンテンツ
          </h5>
          <CustomButton
            onClick={() => goToContentRaking()}
            variant="text"
          >
          すべてみる
          </CustomButton>
        </div>

        <div className="rounded-2xl bg-white p-6 flex flex-col gap-3 alu-section-box-shadow">
          {(!isLoadingTopNews && topNews.length === 0) ? (
            <CompanyTopNewsEmpty text="まだ投稿がありません" key={'topNews'} />
          ) : (
            topNews.map((news: CompanyTopNews, idx: number) => (
              <CompanyTopNews key={idx} idx={idx} news={news} />
            ))
          )}
        </div>
      </div>

      <div className="w-[50%]">
        <div className="mb-4 flex items-center justify-between">
          <h5 className="text-xl alu-text-base-2 font-bold">
            よく見られている求人
          </h5>
          <CustomButton
          onClick={() => goToJobPage()}
          variant="text"
          >
          すべてみる
          </CustomButton>
        </div>

        <div className="rounded-2xl bg-white p-6 flex flex-col gap-3 alu-section-box-shadow">
          {!isLoadingTopNews && topsJobs.length === 0 ? (
            <CompanyTopNewsEmpty text="まだ投稿がありません" key={'topJobs'} />
          ) : (
            topsJobs.map((job: TopJob) => (
              <CompanyTopJobs key={job.id} job={job} />
            )))
          }
        </div>
      </div>
    </div>
  );
}

export default CompanyHomeNewsAndJob;